import React from 'react';
import MaterialTable from "material-table";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from 'moment';
import 'moment-timezone';

import { push } from "../../../router/history";

const Logs = (props) => {
  console.log('propsneaushu', props);
  const moment = require('moment-timezone');
    const [state, setState] = React.useState({
      columns: [
        { title: "Descrição", field: "description" },
        {
          title: "Criado por",
          field: "created_by",
        },
        {
          title: "Criado em",
          field: 'created_at',
          render: row => <span>{moment(row['created_at']).tz('America/Fortaleza').format('YYYY-MM-DD HH:mm:ss') }</span>
        },
      ],
    });
  
    return props.isLoading ? (
      <CircularProgress />
    ) : (
      <MaterialTable
        title="Logs"
        columns={state.columns}
        data={props.data}
        options={{
          actionsColumnIndex: -1,
        }}
        localization={{
          header: {
            actions: "Ações",
          },
        }}
      />
    );
  };

export default Logs;